var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReportTypeEnum } from './enums';
import { render } from 'react-dom';
import * as React from 'react';
import { List } from './components/list';
import '../../scss/report/index.scss';
import { insightsCountNotifierAdd } from "../common/insightsCountNotifierAdd";
import { saveInLocalStorage } from "../common/helpers";
document.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    var root, cdn, getReportType, type, _a, countValue, fetchResult;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                root = document.querySelector('#root');
                cdn = root === null || root === void 0 ? void 0 : root.getAttribute('data-cdn');
                getReportType = function () {
                    switch (root === null || root === void 0 ? void 0 : root.getAttribute('data-type')) {
                        case 'flash':
                            return ReportTypeEnum.Flash;
                        case 'premium':
                            return ReportTypeEnum.Premium;
                        default:
                            return null;
                    }
                };
                type = getReportType();
                if (root && cdn && type) {
                    render(React.createElement(List, { type: type, cdn: cdn }), root);
                }
                return [4, insightsCountNotifierAdd()];
            case 1:
                _a = _b.sent(), countValue = _a.countValue, fetchResult = _a.fetchResult;
                savePageVisitDate();
                if (countValue && fetchResult && fetchResult['unread_flash_count'] !== undefined) {
                    updateCountBlock('flashTitle', fetchResult['unread_flash_count']);
                    updateCountBlock('premiumTitle', countValue - fetchResult['unread_flash_count']);
                }
                return [2];
        }
    });
}); });
var savePageVisitDate = function () {
    var currentDate = new Date();
    saveInLocalStorage('last_insights_page_visit_date', JSON.stringify(currentDate));
};
function updateCountBlock(titleId, totalCount) {
    var titleElement = document.querySelector("#" + titleId);
    var countBlock = titleElement === null || titleElement === void 0 ? void 0 : titleElement.querySelector('.unread-count ');
    if (countBlock && totalCount > 0) {
        countBlock.style.display = 'flex';
        countBlock.textContent = totalCount === null || totalCount === void 0 ? void 0 : totalCount.toString();
    }
}
